var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4243 11.648V11.5827C10.4243 11.1362 10.6312 10.7987 11.0123 10.5264L11.4588 10.2107C12.1012 9.75333 12.5368 9.14356 12.5368 8.28333C12.5368 7.18355 11.6548 6.11644 9.967 6.11644C8.35544 6.11644 7.47344 7.24889 7.47344 8.42489C7.47344 8.58822 7.48433 8.76244 7.52789 8.91489L8.89989 8.96933C8.86722 8.87133 8.85633 8.75156 8.85633 8.62089C8.85633 8.01111 9.19389 7.39044 9.967 7.39044C10.6966 7.39044 11.0559 7.86956 11.0559 8.37044C11.0559 8.69711 10.9143 8.99111 10.5877 9.23067L10.065 9.62267C9.44433 10.0909 9.20478 10.6244 9.20478 11.2016C9.20478 11.3649 9.22656 11.5064 9.24833 11.648H10.4243ZM8.99789 13.2269C8.99789 13.706 9.379 14.0871 9.85811 14.0871C10.3372 14.0871 10.7292 13.706 10.7292 13.2269C10.7292 12.7478 10.3372 12.3558 9.85811 12.3558C9.379 12.3558 8.99789 12.7478 8.99789 13.2269Z",
    fill: "#1A1B1D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 14,
    height: 14,
    rx: 7,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.cb96f3d4633efb4ea75368a688c4a1e8.svg";
export { ForwardRef as ReactComponent };